import { withTracking } from '../../../observability';
import { SectionName } from '../../../observability/tracking/events';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { LogoBar } from './LogoBar';

export default createBuilderModule(
  withTracking(LogoBar, { sectionName: SectionName.LogoBar }),
  {
    name: 'LogoBar',
    image:
      'https://cdn.zapier.com/storage/photos/f9503143fb1b1eaf4dcd839a06ffc9aa.png',
    inputs: [
      {
        name: 'title',
        type: 'string',
        defaultValue: 'Trusted at companies large and small',
        required: true,
      },
      {
        name: 'items',
        type: 'list',
        defaultValue: [],
        subFields: [
          {
            name: 'logoUrl',
            type: 'cloudinaryImage',
            defaultValue:
              'https://cdn.zappy.app/dd2c451262bf37375ce17fedcbaa2d17.svg',
          },
          {
            name: 'companyName',
            type: 'string',
            helperText: 'Used for alt text for the company logo',
            required: true,
          },
          {
            name: 'height',
            type: 'number',
          },
          {
            name: 'width',
            type: 'number',
          },
        ],
      },
    ],
  },
);
